import clsx from "clsx"
import { useEffect, useRef, useState } from "react"
import icChevDown from "./ic-chev-down.svg"
import icSideBar from "./ic-sidebar.svg"
import './menu.scss'
import FloatingText from "../FloatingText"

export const Menu = ({className, contentHeader, items, onClick, onHide, selectedKey, contentFooter}) => {
    const [activeMenu, setActiveMenu] = useState('')
    const [isCollapse, setCollapse] = useState(false)
    const activeParentKey = selectedKey?.split('/')[0]

    return (
        <div 
            className={clsx(
                'avo__menu group',
                isCollapse ? 'max-w-[53px] duration-300 ' : 'max-w-[300px] duration-500',
                className,
            )}
        >
            {contentHeader}
            <button
                className={clsx(
                    'absolute flex items-center justify-center size-8 rounded-lg right-2 top-3 transition-all duration-200 hover:bg-neutral-20 cursor-pointer group-hover:opacity-100 opacity-0',
                    isCollapse && 'invisible',
                )}
                onClick={() => {
                    setCollapse(!isCollapse)
                    setActiveMenu(activeParentKey)
                }}
            >
                <img src={icSideBar} alt='collapse' />
            </button>
            <div className="menu-wrapper">
                {items.map((item, index) => (
                    <MenuItem
                        key={index}
                        item={item}
                        value={null}
                        parentKey={item.slug}
                        onClick={onClick}
                        onHide={onHide}
                        selectedKey={selectedKey}
                        onExpand={() => {
                            setActiveMenu(item.slug)
                            setCollapse(false)
                        }}
                        activeMenu={activeMenu}
                        isCollapse={isCollapse}
                    />
                ))}
            </div>
            {contentFooter(isCollapse)}
        </div>
    )
}

export default Menu

const MenuItem = ({
                      item, level = 0,
                      parentKey,
                      onHide,
                      maxHeight = () => {
                      },
                      onClick,
                      selectedKey,
                      onExpand,
                      activeMenu,
                      isCollapse,
                  }) => {
    const childRef = useRef()
    const [childHeight, setChildHeight] = useState(0)
    const hasChild = !!item?.child
    const lastSelectedKey = selectedKey.split('/').pop()
    const selectedParentKey = selectedKey.split('/').slice(0, -1).join('/')
    const isSelected = lastSelectedKey === item.slug || selectedParentKey === parentKey
    const isExpand = activeMenu === item.slug

    useEffect(() => {
        if (hasChild || level === 0) {
            const firstParentKey = selectedKey.split('/').splice(0, 1).join()
            if (firstParentKey === item.slug) onExpand(item.slug)
        }
    }, [hasChild])

    useEffect(() => {
        maxHeight(childHeight)
    }, [isExpand])

    useEffect(() => {
        if (childRef?.current?.scrollHeight) {
            setChildHeight(childRef?.current?.scrollHeight)
            maxHeight(childRef?.current?.scrollHeight)
        }
    }, [childRef?.current?.scrollHeight])

    const handleOnClick = (e) => {
        e.stopPropagation()
        if (hasChild) return onExpand(item.slug)
        if (level === 0) onExpand(item.slug)
        onClick(parentKey)
        window.scrollTo(0, 0)
        if (onHide) {
            onHide()
        }
    }

    return (
        <>
            <div
                onClick={handleOnClick}
                className={clsx(
                    'relative flex items-center gap-3 h-9 min-w-9 px-2.5 py-1 mb-1 rounded cursor-pointer text-neutral-70 transition-colors duration-200 select-none',
                    isSelected && 'bg-primary-10 text-primary-50',
                    isExpand && 'bg-primary-50 text-white hover:bg-primary-50',
                    isCollapse && 'overflow-hidden',
                    'hover:bg-neutral-20',
                )}
            >
                {item.icon && (
                    <img
                        src={item.icon}
                        alt={item.name}
                        className={clsx('w-4 h-4', isExpand && 'invert brightness-0')}
                    />
                )}
                <FloatingText className={clsx('text-sm font-medium', !hasChild && level > 0 && 'pl-7')}>
                    {item.name}
                </FloatingText>
                {hasChild && (
                    <img
                        src={icChevDown}
                        alt='expand'
                        className={clsx(
                            'ml-auto transition-transform duration-300',
                            isExpand && 'scale-y-[-1] invert brightness-0',
                        )}
                    />
                )}
            </div>
            {hasChild && (
                <div 
                    ref={childRef}                     
                    className='overflow-hidden transition-all duration-300'
                    style={{ maxHeight: isExpand && !isCollapse ? childHeight : 0 }}
                >
                    {item?.child.map((childItem, childIndex) => (
                        <MenuItem
                            key={childIndex}
                            item={childItem}
                            maxHeight={(value) => setChildHeight(childHeight + value)}
                            level={level + 1}
                            parentKey={`${parentKey}/${childItem.slug}`}
                            onClick={onClick}
                            onHide={onHide}
                            selectedKey={selectedKey}
                            activeMenu={activeMenu}
                            isCollapse={isCollapse}
                        />
                    ))}
                </div>
            )}
        </>
    )
}


